import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import history from '../../../../../../../commons/history';
import { setMenuSelection } from '../../../../../../../modules/menu/menu.duck';
import { MASTERIMAGES } from '../../../../../../../commons/api';

class LeftSidePanel extends React.Component {
  render() {
    let craneList = [
      {
        title: 'ECH',
        redirectURL: '/rubus/dashboard/ECH',
        image: `${MASTERIMAGES.ECH_PNG}`,
        redirectMenu: ['Modules', '12235', '12241']
      },
      {
        title: 'Reach Stacker',
        image: `${MASTERIMAGES.RS_PNG}`,
        redirectURL: '/rubus/dashboard/RS',
        redirectMenu: ['Modules', '12235', '12243']
      },
      {
        title: 'ITV',
        image: `${MASTERIMAGES.ITV_PNG}`,
        redirectURL: '/rubus/dashboard/ITV',
        redirectMenu: ['Modules', '12235', '12245']
      },
      {
        title: 'GIS Tracking',
        image: `${MASTERIMAGES.GISTRACKING_PNG}`
      },
      {
        title: 'MHC',
        image: `${MASTERIMAGES.ST_MHC_V1_PNG}`,
        redirectURL: '/rubus/HMI/distinct/MHC/deviceCode',
        redirectMenu: ['Modules', '1218', '1220']
      },
      {
        title: 'QC',
        image: `${MASTERIMAGES.ST_QC_V1_PNG}`,
        redirectURL: '/rubus/HMI/static/QC SVG',
        redirectMenu: ['Modules', '1136', '1138']
      },
      {
        title: 'RTG',
        image: `${MASTERIMAGES.ST_RTG_V1_PNG}`,
        redirectURL: '/rubus/HMI/static/RTG',
        redirectMenu: ['Modules', '1144', '1146']
      }
    ];
    return (
      <>
        {craneList &&
          Array.isArray(craneList) &&
          craneList.map((crane) => {
            return (
              <>
                <img
                  style={{ cursor: 'pointer' }}
                  height="60"
                  weight="60"
                  onClick={() => {
                    if (crane.redirectURL) {
                      this.props.actions.setMenuSelection(crane.redirectMenu);
                      history.push(crane.redirectURL);
                    }
                  }}
                  src={crane.image}
                />
                <div>{crane.title}</div>
              </>
            );
          })}
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({});
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setMenuSelection
      },
      dispatch
    )
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LeftSidePanel);
